import { useState } from "react";
import { Box, Typography, Menu, MenuItem, Divider } from "@mui/material";
import {
  AccountCircle,
  Lock,
  ExitToApp,
  AdminPanelSettings,
} from "@mui/icons-material";

import { styles } from "./styles";
import { Paths } from "../../common/constants";
import useHeaderHelper from "./helper";
import SimpleModal from "../simpleModal";
import ForcePasswordChangeDialog from "../forcePasswordChangeDialog";

const Header = () => {
  const {
    userData,
    pathName,
    handleLogout,
    parsedBrand,
    parsedCountry,
    handleNavigate,
    handleRbac,
    showRbacButton,
  } = useHeaderHelper();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    setChangePasswordOpen(true);
    handleClose();
  };

  const handlePasswordDialogClose = () => {
    setChangePasswordOpen(false);
  };

  const handleLogoutClick = () => {
    handleClose();
    handleLogout();
  };

  return (
    <>
      <Box sx={styles.header}>
        <Box sx={styles.headerLeft}>
          {!pathName.includes(Paths.ORGANIZATION) &&
            !pathName.includes("report") && (
              <>
                <Box sx={styles.nameContainer} onClick={handleNavigate}>
                  <Box
                    component="img"
                    src={parsedCountry?.image}
                    alt="country"
                  />
                  <Typography
                    sx={styles.entityName}
                  >{`${parsedCountry?.name}`}</Typography>
                </Box>
                {!pathName.includes("device") &&
                  !pathName.includes("content") &&
                  !pathName.includes("bulk") && (
                    <Box sx={styles.nameContainer} onClick={handleNavigate}>
                      <Box
                        component="img"
                        src={parsedBrand?.image}
                        alt="search"
                      />
                      <Typography
                        sx={styles.entityName}
                      >{`${parsedBrand?.name}`}</Typography>
                    </Box>
                  )}
              </>
            )}
        </Box>
        <Box sx={styles.notification}>
          <Box sx={styles.userContainer} onClick={handleClick}>
            <AccountCircle sx={styles.picture} />
            <Box>
              <Typography sx={styles.name}>
                {userData?.name || localStorage.getItem("name")}
              </Typography>
              <Typography sx={styles.role}>
                {showRbacButton ? "Super Admin" : ""}
              </Typography>
            </Box>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            PaperProps={{
              sx: styles.menuPaper,
            }}
            MenuListProps={{
              sx: styles.menuList,
            }}
            transitionDuration={200}
          >
            {showRbacButton && (
              <MenuItem onClick={handleRbac} sx={styles.menuItem}>
                <Box sx={styles.menuItemContent}>
                  <Box sx={styles.iconWrapper} className="menu-icon-wrapper">
                    <AdminPanelSettings sx={styles.menuIcon} />
                  </Box>
                  <Typography sx={styles.menuItemText}>RBAC</Typography>
                </Box>
              </MenuItem>
            )}
            {showRbacButton && <Divider sx={styles.menuDivider} />}
            <MenuItem onClick={handleChangePassword} sx={styles.menuItem}>
              <Box sx={styles.menuItemContent}>
                <Box sx={styles.iconWrapper} className="menu-icon-wrapper">
                  <Lock sx={styles.menuIcon} />
                </Box>
                <Typography sx={styles.menuItemText}>
                  Change Password
                </Typography>
              </Box>
            </MenuItem>
            <Divider sx={styles.menuDivider} />
            <MenuItem
              onClick={handleLogoutClick}
              sx={{ ...styles.menuItem, ...styles.logoutMenuItem }}
            >
              <Box sx={styles.menuItemContent}>
                <Box
                  sx={{ ...styles.iconWrapper, ...styles.logoutIconWrapper }}
                  className="menu-icon-wrapper"
                >
                  <ExitToApp sx={styles.menuIcon} />
                </Box>
                <Typography
                  sx={{ ...styles.menuItemText, ...styles.logoutText }}
                >
                  Logout
                </Typography>
              </Box>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
      <SimpleModal
        handleClose={handlePasswordDialogClose}
        isOpen={changePasswordOpen}
      >
        <ForcePasswordChangeDialog
          open={changePasswordOpen}
          onClose={handlePasswordDialogClose}
        />
      </SimpleModal>
    </>
  );
};

export default Header;
